<script scoped>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "AllSetupBatchTimer",
  props: ["selectedData"],
  watch: {
    selectedData: function (newVal, oldVal) {
      console.log('selectedData props',newVal, oldVal)
      if (newVal != oldVal) {
        this.formData = null;
        this.formData = { ...newVal };
      }
    },
  },
  emits: ["submitBatchTimer"],
  data() {
    return {
      formData: {
        timer: "",
        output_soal_pg: "",
        output_soal_bs: "",
        output_soal_mj: "",
        output_soal_pgsk: "",
        output_soal_text: "",
        output_soal_bssk: "",
      },
    };
  },
  methods: {
    submitForm() {
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      this.formData.jadwal_idjadwal = this.$route.params.id;
      this.formData.jadwal_batch_idjadwal_batch = this.$route.params.idbatch;
      const authToken = localStorage.access_token;
      const config = {
        method: "post",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          `master/jadwal-pelaksanaan/${this.idjadwal}/setup-jadwal/batch/${this.idjadwal_batch}/timer`,
        data: this.formData,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + authToken,
        },
      };
      axios(config)
        .then((response) => {
          console.log("Response:", response.data);
          Swal.fire({
            icon: "success",
            title: "Berhasil",
          });
          this.resetForm();
          this.$emit("submitBatchTimer");
        })
        .catch((error) => {
          console.error("Error:", error.response.data);
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text: error.response.data.meta.message,
          });
        });
    },
    resetForm() {
      this.formData = {
        timer: "",
        output_soal_pg: "",
        output_soal_bs: "",
        output_soal_mj: "",
        output_soal_pgsk: "",
        output_soal_text: "",
        output_soal_bssk: "",
        jadwal_idjadwal: "",
        jadwal_batch_idjadwal_batch: "",
      };
    },
  },
  mounted() {
    // Code to run when the component is mounted
  },
};
</script>

<template>
  <!-- {{ formData }} -->
  <div class="container">
    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <div class="mb-3">
        <label for="timer" class="form-label">Output Timer (menit)</label>
        <div class="input-group">
          <input
            v-model="formData.timer"
            class="form-control"
            id="timer"
            type="number"
            required
          />
          <span class="input-group-text"> menit </span>
        </div>
      </div>
      <div class="row mb-3">
        <div class="12">
          <label for="pilihan_ganda" class="form-label">
            Output Pilihan Ganda
          </label>
          <div class="input-group">
            <input
              v-model="formData.output_soal_pg"
              class="form-control"
              id="pilihan_ganda"
              type="number"
              :disabled="
                formData.level_idlevel != 1 && formData.level_idlevel != 2
              "
              :required="
                formData.level_idlevel == 1 || formData.level_idlevel == 2
              "
            />
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="12">
          <label for="pilihan_ganda_sk" class="form-label">
            Output Pilihan Ganda Studi Kasus
          </label>
          <div class="input-group">
            <input
              v-model="formData.output_soal_pgsk"
              class="form-control"
              id="pilihan_ganda_sk"
              type="number"
              :disabled="formData.level_idlevel != 3"
              :required="formData.level_idlevel == 3"
            />
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="12">
          <label for="benar_salah" class="form-label">Output Benar Salah</label>
          <div class="input-group">
            <input
              v-model="formData.output_soal_bs"
              class="form-control"
              id="benar_salah"
              type="number"
              :disabled="formData.level_idlevel != 2"
              :required="formData.level_idlevel == 2"
            />
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="12">
          <label for="benar_salah_sk" class="form-label">
            Output Benar Salah Studi Kasus
          </label>
          <div class="input-group">
            <input
              v-model="formData.output_soal_bssk"
              class="form-control"
              id="benar_salah_sk"
              type="number"
              :disabled="formData.level_idlevel != 3"
              :required="formData.level_idlevel == 3"
            />
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="12">
          <label for="menjodohkan" class="form-label">Output Menjodohkan</label>
          <div class="input-group">
            <input
              v-model="formData.output_soal_mj"
              class="form-control"
              id="menjodohkan"
              type="number"
              :disabled="formData.level_idlevel != 2"
              :required="formData.level_idlevel == 2"
            />
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="12">
          <label for="text" class="form-label">Output Text</label>
          <div class="input-group">
            <input
              v-model="formData.output_soal_text"
              class="form-control"
              id="text"
              type="number"
              :disabled="formData.level_idlevel != 4"
              :required="formData.level_idlevel == 4"
            />
          </div>
        </div>
      </div>
      <div class="mb-3 float-end">
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>
  </div>
</template>
